let routes = [
  {
    path: '/demande-permis-psychologue-regulier',
    component: () => import('../views/DemandePermisPsychologueRegulier.vue'),
    props: true
  },
  {
    path: '/demande-permis-psychologue-regulier/:step',
    component: () => import('../views/DemandePermisPsychologueRegulier.vue'),
    props: true
  }
]

export default routes;